document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.getElementById("stickyQty");
  const plusBtn = document.querySelector(".qty-btn.plus");
  const minusBtn = document.querySelector(".qty-btn.minus");
  const addToCartBtn = document.getElementById("stickyAddToCart");
  const stickyCart = document.getElementById("stickyCart");

  // ✅ Target ONLY the form inside .product__info-container
  const productForm = document.querySelector(
    ".product__info-container form[action*='/cart/add']"
  );

  const mainQty = document.querySelector('input[name="quantity"]');

  // ✅ Derive main button and variant input from the right form only
  const mainAddBtn = productForm?.querySelector('button[type="submit"]');
  const variantIdInput = productForm?.querySelector('input[name="id"]');

  const productInfoSection =
    productForm?.closest(".product__info-container") || productForm;

  // If sticky UI isn't on the page, don't attach listeners.
  if (!qtyInput || !plusBtn || !minusBtn || !addToCartBtn || !stickyCart) return;
  // If the main product form isn't found, don't run either.
  if (!productForm) return;

  const DEFAULT_LABEL = "Add to Cart";
  const CHOOSE_LABEL = "Choose Color";
  const ADDED_LABEL = "Added ✓";
  const ADDED_RESET_DELAY = 2000;

  const VISIBLE_CLASS = "is-visible";

  let addedTimeout = null;

  // ---------------------------------------------------------------
  // Sticky bar visibility
  // ---------------------------------------------------------------
  function updateStickyVisibility() {
    if (!productForm) return;
    const rect = productForm.getBoundingClientRect();
    const pastForm = rect.bottom < 0;
    const nextDisplay = pastForm ? "flex" : "none";

    if (stickyCart.style.display !== nextDisplay) {
      stickyCart.style.display = nextDisplay;
    }

    if (pastForm) {
      if (!stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.add(VISIBLE_CLASS);
      }
      stickyCart.style.removeProperty("visibility");
      stickyCart.style.removeProperty("opacity");
      stickyCart.style.removeProperty("pointer-events");
    } else {
      if (stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.remove(VISIBLE_CLASS);
      }
    }
  }

  function assertVisibilityBurst() {
    updateStickyVisibility();
    [50, 150, 300, 600, 1000].forEach((t) =>
      setTimeout(updateStickyVisibility, t)
    );
  }

  // ---------------------------------------------------------------
  // Variant detection
  // ---------------------------------------------------------------
  function isVariantSelected() {
    if (mainAddBtn && mainAddBtn.disabled) return false;
    if (variantIdInput && !variantIdInput.value) return false;
    return true;
  }

  // ---------------------------------------------------------------
  // Button state
  // ---------------------------------------------------------------
  function syncButtonState() {
    if (addToCartBtn.dataset.state === "added") return;

    if (isVariantSelected()) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = DEFAULT_LABEL;
      addToCartBtn.dataset.state = "ready";
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = CHOOSE_LABEL;
      addToCartBtn.dataset.state = "choose";
    }
  }

  // ---------------------------------------------------------------
  // Initial checks
  // ---------------------------------------------------------------
  syncButtonState();
  updateStickyVisibility();
  assertVisibilityBurst();
  window.addEventListener("load", assertVisibilityBurst);

  if (mainAddBtn) {
    const btnObserver = new MutationObserver(syncButtonState);
    btnObserver.observe(mainAddBtn, {
      attributes: true,
      attributeFilter: ["disabled"],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (variantIdInput) {
    variantIdInput.addEventListener("change", syncButtonState);
    const inputObserver = new MutationObserver(syncButtonState);
    inputObserver.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  if (productForm) {
    productForm.addEventListener("click", () => setTimeout(syncButtonState, 50));
    productForm.addEventListener("change", () => setTimeout(syncButtonState, 50));
  }

  // ---------------------------------------------------------------
  // Quantity sync
  // ---------------------------------------------------------------
  function syncQty(value) {
    qtyInput.value = value;
    if (mainQty) {
      mainQty.value = value;
      mainQty.dispatchEvent(new Event("change"));
    }
  }

  plusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    syncQty(++val);
  });

  minusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val > 1) syncQty(--val);
  });

  qtyInput.addEventListener("input", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val < 1) val = 1;
    syncQty(val);
  });

  // ---------------------------------------------------------------
  // "Added" state
  // ---------------------------------------------------------------
  function showAddedState() {
    addToCartBtn.dataset.state = "added";
    addToCartBtn.textContent = ADDED_LABEL;
    addToCartBtn.disabled = true;

    clearTimeout(addedTimeout);
    addedTimeout = setTimeout(() => {
      addToCartBtn.dataset.state = "ready";
      syncButtonState();
      assertVisibilityBurst();
    }, ADDED_RESET_DELAY);
  }

  // ---------------------------------------------------------------
  // Watch cart mutations
  // ---------------------------------------------------------------
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === "string" ? request : request?.url || "";
    const isAddToCart = url.includes("/cart/add");

    return originalFetch.apply(this, args).then(async (response) => {
      if (isAddToCart && response.ok) {
        showAddedState();
        assertVisibilityBurst();
      }
      return response;
    });
  };

  // ---------------------------------------------------------------
  // Cart / drawer events
  // ---------------------------------------------------------------
  ["cart:updated", "cart:refresh", "cart:change"].forEach((ev) =>
    document.addEventListener(ev, assertVisibilityBurst)
  );

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.addEventListener("cart:updated", assertVisibilityBurst);
  }

  const cartDrawerItems =
    document.querySelector("cart-drawer-items") ||
    document.querySelector(".cart-drawer__items") ||
    document.querySelector("#CartDrawer");
  if (cartDrawerItems) {
    let drawerTimeout = null;
    const drawerObserver = new MutationObserver(() => {
      clearTimeout(drawerTimeout);
      drawerTimeout = setTimeout(assertVisibilityBurst, 150);
    });
    drawerObserver.observe(cartDrawerItems, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("click", (e) => {
    const t = e.target;
    if (
      t.closest("cart-drawer") ||
      t.closest(".cart-drawer") ||
      t.closest("[data-cart-drawer]") ||
      t.closest('a[href*="/cart"]')
    ) {
      assertVisibilityBurst();
    }
  });

  // ---------------------------------------------------------------
  // Fight back if the theme hides the bar
  // ---------------------------------------------------------------
  const bodyObserver = new MutationObserver(() => {
    const rect = productForm?.getBoundingClientRect();
    if (rect && rect.bottom < 0) {
      updateStickyVisibility();
    }
  });
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "style"],
  });

  const stickyObserver = new MutationObserver(() => {
    const rect = productForm?.getBoundingClientRect();
    if (rect && rect.bottom < 0) {
      if (stickyCart.style.display === "none") {
        stickyCart.style.display = "flex";
      }
      if (!stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.add(VISIBLE_CLASS);
      }
    } else {
      if (stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.remove(VISIBLE_CLASS);
      }
    }
  });
  stickyObserver.observe(stickyCart, {
    attributes: true,
    attributeFilter: ["style", "class"],
  });

  // ---------------------------------------------------------------
  // Sticky click
  // ---------------------------------------------------------------
  addToCartBtn.addEventListener("click", () => {
    if (addToCartBtn.dataset.state === "choose") {
      if (productInfoSection) {
        productInfoSection.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    if (!mainAddBtn || addToCartBtn.disabled) return;

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = "Adding...";

    mainAddBtn.click();
    assertVisibilityBurst();

    setTimeout(() => {
      if (addToCartBtn.dataset.state !== "added") {
        syncButtonState();
      }
    }, 5000);
  });

  // ---------------------------------------------------------------
  // Scroll / resize
  // ---------------------------------------------------------------
  window.addEventListener("scroll", updateStickyVisibility, { passive: true });
  window.addEventListener("resize", updateStickyVisibility);
});